import { render, staticRenderFns } from "./SettlementType.vue?vue&type=template&id=3c1df653&scoped=true&"
import script from "./SettlementType.vue?vue&type=script&lang=js&"
export * from "./SettlementType.vue?vue&type=script&lang=js&"
import style0 from "./SettlementType.vue?vue&type=style&index=0&id=3c1df653&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1df653",
  null
  
)

export default component.exports